import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import unformat from 'accounting-js/lib/unformat.js';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Property } from 'app/modules/projects/projects.types';
import { PropertyTenantsService } from '../../tenants.service';
import { ProjectType, PropertyType, ProjectStage } from 'app/core/models/account.types';
import { CurrencyMaskOptions, getCurrencyMask } from 'app/shared/Utils/common.utils';
import { AccountService } from 'app/core';
import { PropertyTenant, PropertyUnit } from 'app/modules/projects/details/tenants/tenants.types';
import moment from 'moment';
import { Observable, noop, of, tap } from 'rxjs';

@Component({
  selector: 'property-tenants-rent-schedule',
  templateUrl: './rent-schedule.component.html',
  styleUrls: ['./rent-schedule.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PropertyTenantsRentScheduleComponent extends OnDestroyMixin implements OnInit {
  propertyTenantForm: UntypedFormGroup;
  projectTypes: ProjectType[];
  propertyTypes: PropertyType[];
  projectStages: ProjectStage[];
  property: Property;
  propertyUnit: PropertyUnit;
  propertyTenant: PropertyTenant;
  public uploadedFile: any;
  public isLoading: boolean;
  options: [];
  ui = { isLoading: true };
  public rentSchedules: any;
  displayColumns: string[] = ['as_of_date', 'val'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly matDialogRef: MatDialogRef<PropertyTenantsRentScheduleComponent>,
    private _accountService: AccountService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly propertyTenantsService: PropertyTenantsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.property = this.data.property;
    this.propertyUnit = this.data.propertyUnit;
    this.propertyTenant = this.data.propertyTenant;
    this.propertyTenantsService
      .getRentSchedules(this.property.id, this.propertyUnit.id, this.propertyTenant.id)
      .subscribe((data) => {
        this.rentSchedules = data;
      });
  }

  public discard(): void {
    this.matDialogRef.close();
  }
}
